import {
  ADD_COMPONENT,
  REMOVE_COMPONENT,
  SET_CLIENT,
  SET_CLIENTS_LIST,
  SET_CURRENT_LOAD,
  SET_DEFAULT_INSTALLATION,
  SET_DESIGNATION,
  SET_EXTERNAL_ID,
  SET_FLUID_CODE,
  SET_INTEGRATED_LEAK_DETECTOR,
  SET_LAST_LEAK_DETECTION_DATE,
  SET_MARK,
  SET_NOMENCLATURES_LIST,
  SET_NOMINAL_LOAD,
  SET_SITE,
  SET_SITES_LIST,
} from "../constants";

const initialState = {
  clientsList: [],
  clientsOptions: [],
  sitesList: [],
  siteOptions: [],
  nomenclaturesList: [],
  client: undefined,
  clientInfos: undefined,
  site: undefined,
  siteInfos: undefined,
  designation: undefined,
  mark: undefined,
  lastLeakDetectionDate: undefined,
  integratedLeakDetector: undefined,
  fluidCode: undefined,
  currentLoad: undefined,
  nominalLoad: undefined,
  components: [],
  interventions: [],
  addedComponents: [],
};

export default function installationEditFormReducer(
  state = initialState,
  action
) {
  const { type, payload } = action;
  switch (type) {
    case SET_SITES_LIST:
      return {
        ...state,
        sitesList: payload,
        siteOptions: getSitesFromClient(payload, state.client),
        siteInfos: setSiteInfos(payload, state.site),
      };
    case SET_CLIENTS_LIST:
      return {
        ...state,
        clientsList: payload,
        clientsOptions: payload,
        clientInfos: setClientInfos(payload, state.client),
      };
    case SET_NOMENCLATURES_LIST:
      return { ...state, nomenclaturesList: payload };
    case SET_CLIENT:
      return {
        ...state,
        siteOptions: getSitesFromClient(state.sitesList, payload),
        client: payload,
        clientInfos: setClientInfos(state.clientsList, payload),
        site: undefined,
        siteInfos: undefined,
      };
    case SET_SITE: {
      return {
        ...state,
        site: payload,
        siteInfos: setSiteInfos(state.sitesList, payload),
      };
    }
    case SET_EXTERNAL_ID:
      return {
        ...state,
        externalId: payload,
      };
    case SET_DESIGNATION:
      return {
        ...state,
        designation: payload,
      };
    case SET_MARK:
      return {
        ...state,
        mark: payload,
      };
    case SET_LAST_LEAK_DETECTION_DATE:
      return {
        ...state,
        lastLeakDetectionDate: payload,
      };
    case SET_INTEGRATED_LEAK_DETECTOR:
      return {
        ...state,
        integratedLeakDetector: payload,
      };
    case SET_FLUID_CODE:
      return {
        ...state,
        fluidCode: payload,
      };
    case SET_CURRENT_LOAD:
      return {
        ...state,
        currentLoad: payload,
      };
    case SET_NOMINAL_LOAD:
      return {
        ...state,
        nominalLoad: payload,
      };
    case SET_DEFAULT_INSTALLATION:
      return {
        ...state,
        ...payload,
        clientInfos: setClientInfos(state.clientsList, payload.client),
        siteInfos: setSiteInfos(state.sitesList, payload.site),
        siteOptions: getSitesFromClient(state.sitesList, payload.client),
      };

    case ADD_COMPONENT:
      return {
        ...state,
        addedComponents: [...state.addedComponents, payload],
      };

    case REMOVE_COMPONENT:
      return {
        ...state,
        addedComponents: state.addedComponents.filter(
          (c) => c.uuid !== payload
        ),
      };
    default:
      return state;
  }
}

function getSitesFromClient(sitesList, clientUuid) {
  return sitesList.filter((site) => !site.mobile && site.client.uuid === clientUuid);
}

function setSiteInfos(sitesList, siteUuid) {
  return sitesList.find((site) => site.uuid === siteUuid);
}

function setClientInfos(clientsList, clientUuid) {
  return clientsList.find((client) => client.uuid === clientUuid);
}
